import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Table } from '../../../common/table'
import { mapTableOfOwnershipStructure } from '../constants'
import {
  selectOwnershipStructureData,
  selectOwnershipStructureIds,
} from '../store/slice'
import { NameCell } from './NameCell'

export const OwnershipStructureTable = ({
  getIdFromRedux,
  getDataFromRedux,
  sort,
  onChangeSort,
  isDynamicReport,
  isHistory,
}) => {
  const ids = useSelector(getIdFromRedux)

  return (
    <Table
      autoHeightMax={isDynamicReport ? undefined : 300}
      ids={ids}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isStickyFirstCol={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      noDataText="companyAnalysis.ownershipAndGroup.OWNERSHIP_STRUCTURE_NO_DATA"
      getDataFromRedux={getDataFromRedux}
      sort={sort}
      changeSort={onChangeSort}
      schema={Object.values(mapTableOfOwnershipStructure).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          thStyle: item.thStyle,
          parentThStyle: isDynamicReport ? {} : item.parentThStyle,
          sortable: isHistory ? item.sortable : undefined,
          render: (val, { rowId, locale }) => {
            switch (item.key) {
              case mapTableOfOwnershipStructure.ownershipName.key:
                return (
                  <NameCell
                    item={item}
                    val={val}
                    rowId={rowId}
                    isDynamicReport={isDynamicReport}
                    getDataFromRedux={getDataFromRedux}
                  />
                )

              case mapTableOfOwnershipStructure.percentage.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              case mapTableOfOwnershipStructure.publicDateId.key:
                return item.format(val, locale)

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}

OwnershipStructureTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}

OwnershipStructureTable.defaultProps = {
  getIdFromRedux: selectOwnershipStructureIds,
  getDataFromRedux: selectOwnershipStructureData,
}
